import { PreChatActionTypes } from './preChat.types';

export const initialState = {
  loading: false,
  diagnosticLoaded: false,
  invoices: {},
  refunds: [],
  backups: [],
  backup_available: [],
  duplicateOrders: [],
  pendingOrders: [],
  customer: {},
  invoiceId: null,
  screenToShowInPreChat: 'diagnostic',
  trustReactivation: [],
  billingGenerated: false,
  reactivationRedirect: false,
  trustReactivationInvoiceId: null,
  invoiceTicketWillOpen: false,
  productsList: {},
  subscriptions: {},
  productsLoading: true,
  triage: {
    subscriptionToCancel: null,
    subscriptionToChangePaymentMethod: null,
    holdDomainRedirect: false,
    onEppKeyFlow: false,
    domainReservedFlow: false,
    redirectManageSubscription: false,
  },
  domainsPropagation: [],
  tos: {
    redirect: false,
    tickets: [],
  },
  vpsUpgrade: {
    redirect: false,
    termsAccepted: false,
    productId: null,
  },
  productDetails: {},
  productDetailsLoading: false,
  weekDay: null,
  ssl: [],
  sitelock: [],
  showPreChat: false,
  hasActiveChat: undefined,
  ticketType: null,
  chatbotSessionID: null,
  lastChatbotMessage: null,
};

const preChatReducer = (state = initialState, action) => {
  switch (action.type) {
    case PreChatActionTypes.SET_DIAGNOSTIC_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case PreChatActionTypes.SET_DIAGNOSTIC: {
      const { diagnostic } = action.payload;

      return {
        ...state,
        invoices: diagnostic.invoices,
        subscriptions: diagnostic.subscriptions,
        refunds: diagnostic.refunds,
        backups: diagnostic.backups,
        backup_available: diagnostic.backup_available,
        customer: diagnostic.customer,
        trustReactivation: diagnostic.trustReactivation,
        domainsPropagation: diagnostic.domains_propagation,
        duplicateOrders: diagnostic.duplicate_orders,
        pendingOrders: diagnostic.pending_orders,
        tos: {
          ...state.tos,
          tickets: diagnostic.tickets,
        },
        ssl: diagnostic.ssl,
        sitelock: diagnostic.sitelock,
      };
    }
    case PreChatActionTypes.SET_INVOICE_ID: {
      return {
        ...state,
        invoiceId: action.payload,
      };
    }
    case PreChatActionTypes.SET_SCREEN_TO_SHOW_IN_PRECHAT: {
      return {
        ...state,
        screenToShowInPreChat: action.payload,
      };
    }
    case PreChatActionTypes.GET_DIAGNOSTIC_SUCCESS: {
      return {
        ...state,
        diagnosticLoaded: true,
      };
    }
    case PreChatActionTypes.GET_DIAGNOSTIC_FAILURE: {
      return {
        ...state,
        diagnosticLoaded: false,
      };
    }
    case PreChatActionTypes.BILLING_GENERATED: {
      return {
        ...state,
        billingGenerated: action.payload,
      };
    }
    case PreChatActionTypes.REACTIVATION_REDIRECT: {
      return {
        ...state,
        reactivationRedirect: action.payload,
      };
    }
    case PreChatActionTypes.SET_TRUST_REACTIVATION_INVOICE_ID: {
      return {
        ...state,
        trustReactivationInvoiceId: action.payload,
      };
    }
    case PreChatActionTypes.SET_INVOICE_TICKET_WILL_OPEN: {
      return {
        ...state,
        invoiceTicketWillOpen: action.payload,
      };
    }
    case PreChatActionTypes.SET_PRODUCT_BY_STATUS: {
      return {
        ...state,
        productsList: action.payload.productsList,
      };
    }
    case PreChatActionTypes.SET_PRODUCTS_BY_STATUS_LOADING: {
      return {
        ...state,
        productsLoading: action.payload,
      };
    }
    case PreChatActionTypes.SET_SUBSCRIPTION_TO_CANCEL: {
      return {
        ...state,
        triage: {
          ...state.triage,
          subscriptionToCancel: action.payload,
        },
      };
    }
    case PreChatActionTypes.SET_SUBSCRIPTION_TO_CHANGE_PAYMENT_METHOD: {
      return {
        ...state,
        triage: {
          ...state.triage,
          subscriptionToChangePaymentMethod: action.payload,
        },
      };
    }
    case PreChatActionTypes.SET_TOS_REDIRECT: {
      return {
        ...state,
        tos: {
          ...state.tos,
          redirect: action.payload,
        },
      };
    }
    case PreChatActionTypes.SET_VPS_REDIRECT: {
      return {
        ...state,
        vpsUpgrade: {
          ...state.vpsUpgrade,
          redirect: action.payload,
        },
      };
    }
    case PreChatActionTypes.SET_VPS_PRODUCT_ID: {
      return {
        ...state,
        vpsUpgrade: {
          ...state.vpsUpgrade,
          productId: action.payload,
        },
      };
    }
    case PreChatActionTypes.SET_VPS_TERMS_ACCEPTED: {
      return {
        ...state,
        vpsUpgrade: {
          ...state.vpsUpgrade,
          termsAccepted: action.payload,
        },
      };
    }
    case PreChatActionTypes.SET_PRODUCT_DETAILS_LOADING: {
      return {
        ...state,
        productDetailsLoading: action.payload,
      };
    }
    case PreChatActionTypes.SET_PRODUCT_DETAILS: {
      return {
        ...state,
        productDetails: action.payload,
      };
    }
    case PreChatActionTypes.SET_HOLD_REDIRECT: {
      return {
        ...state,
        triage: {
          ...state.triage,
          holdDomainRedirect: action.payload,
        },
      };
    }
    case PreChatActionTypes.SET_EPP_KEY_FLOW: {
      return {
        ...state,
        triage: {
          ...state.triage,
          onEppKeyFlow: action.payload,
        },
      };
    }
    case PreChatActionTypes.SET_RESERVED_DOMAIN_FLOW: {
      return {
        ...state,
        triage: {
          ...state.triage,
          domainReservedFlow: action.payload,
        },
      };
    }
    case PreChatActionTypes.SET_WEEK_DAY: {
      return {
        ...state,
        weekDay: action.payload,
      };
    }
    case PreChatActionTypes.SET_SUBSCRIPTION_REDIRECT_FROM_PRECHAT: {
      return {
        ...state,
        triage: {
          ...state.triage,
          redirectManageSubscription: action.payload,
        },
      };
    }
    case PreChatActionTypes.SET_SHOW_PRE_CHAT: {
      return {
        ...state,
        showPreChat: typeof action.payload === 'boolean' ? action.payload : !state.showPreChat,
      };
    }
    case PreChatActionTypes.SET_ACTIVE_CHAT: {
      return {
        ...state,
        hasActiveChat: action.payload,
      };
    }
    case PreChatActionTypes.SET_TICKET_TYPE: {
      return {
        ...state,
        ticketType: action.payload,
      };
    }
    case PreChatActionTypes.SET_CHATBOT_SESSION_ID: {
      return {
        ...state,
        chatbotSessionID: action.payload,
      };
    }
    case PreChatActionTypes.SET_CHATBOT_MESSAGE: {
      return {
        ...state,
        lastChatbotMessage: action.payload,
      };
    }
    default:
      return state;
  }
};

export default preChatReducer;
